import React from "react";
import Select from "react-select";
import { Button } from "aible";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMinus, faPlus, faEye } from "@fortawesome/free-solid-svg-icons";

import styles from "./style.module.css";

import { STEP_TYPE, WIZARD_SECTIONS, ORIGINAL_STEPS } from "containers/Wizard/reducer";
import { PROJECT_MODES } from "containers/Run/reducer";

export default class Wizard extends React.PureComponent {
  renderMonitoring() {
    const { monitoring, rightPanel } = this.props;

    return (
      <div className={styles.monitoring}>
        {monitoring}
        {rightPanel}
      </div>
    );
  }

  renderMonitoringDemo() {
    const { monitoringDemo, rightPanel } = this.props;

    return (
      <div className={styles.monitoring}>
        {monitoringDemo}
        {rightPanel}
      </div>
    );
  }

  renderMonitorGroup() {
    const { monitorGroup, rightPanel } = this.props;

    return (
      <div className={styles.monitoring}>
        {monitorGroup}
        {rightPanel}
      </div>
    );
  }

  renderAudit() {
    const { audit, rightPanel } = this.props;

    return (
      <div className={styles.audit} style={{ width: "100%" }}>
        {audit}
        {rightPanel}
      </div>
    );
  }

  renderRun() {
    const {
      id,
      blueprintId,
      isEditBlueprint,
      isAdvanced,
      steps,
      stepsContainer,
      rightPanel,
      start,
      header,
      addStep,
      removeStepById,
      modelType,
      aibleMode,
      hoverStep,
      scrollToId,
      updateSteps,
      updateHoverStep,
      createBlueprint
    } = this.props;

    return (
      <div className={styles.run}>
        {isEditBlueprint === true && isAdvanced === true && (
          <div className={styles.stepPicker}>
            <div className={styles.stepHeader + " " + styles.secondBack}>
              <div className={styles.info}>
                <div className={styles.infoFirst}>{"Type: "}</div>
                <div className={styles.mode}>{modelType}</div>
              </div>
              <div className={styles.info}>
                <div className={styles.infoFirst}>{"Mode: "}</div>
                <div className={styles.mode}>{aibleMode}</div>
              </div>
            </div>
            {modelType === undefined && aibleMode === undefined ? (
              <div className={styles.addSteps}>
                <div className={styles.stepHeader}>{"Select model type and Aible Mode"}</div>
              </div>
            ) : (
              <div className={styles.addSteps} style={id !== "new" ? { height: "calc(100vh - 280px)" } : {}}>
                {Object.keys(WIZARD_SECTIONS).map((w) => {
                  return (
                    <div key={w}>
                      <div className={styles.stepHeader}>{WIZARD_SECTIONS[w]}</div>
                      {Object.keys(STEP_TYPE)
                        .filter(
                          (s) =>
                            (STEP_TYPE[s].type === undefined || STEP_TYPE[s].type === modelType) &&
                            STEP_TYPE[s].section === WIZARD_SECTIONS[w]
                        )
                        .filter((s) => STEP_TYPE[s].isHiddenFromMenu !== true)
                        .map((s, i) => {
                          const isRemove = steps.indexOf(STEP_TYPE[s].id) !== -1;

                          return (
                            <div
                              className={styles.stepButton + " " + (isRemove ? styles.removeBtn : styles.addBtn)}
                              key={i}
                              onClick={() => {
                                !isRemove && addStep(blueprintId, STEP_TYPE[s].id) && updateHoverStep(STEP_TYPE[s].id);
                                scrollToId(blueprintId, STEP_TYPE[s].id);
                              }}
                            >
                              <div
                                className={styles.stepIcon}
                                title={(isRemove ? "Remove" : "Add") + " Step - " + STEP_TYPE[s].id}
                              >
                                <Button
                                  type="secondary"
                                  className={styles.sButton}
                                  onClick={
                                    isRemove
                                      ? (e) => {
                                          e.stopPropagation();
                                          removeStepById(blueprintId, STEP_TYPE[s].id);
                                        }
                                      : (e) => {
                                          e.stopPropagation();
                                          addStep(blueprintId, STEP_TYPE[s].id);
                                        }
                                  }
                                  style={{
                                    padding: "5px",
                                    paddingTop: "0px",
                                    paddingBottom: "0px"
                                  }}
                                >
                                  <FontAwesomeIcon icon={isRemove ? faMinus : faPlus} />
                                </Button>
                              </div>
                              <div className={isRemove ? "" : styles.canAdd}>
                                {STEP_TYPE[s].id.replace("_", "  ").toLowerCase()}
                              </div>
                            </div>
                          );
                        })}
                    </div>
                  );
                })}
              </div>
            )}
          </div>
        )}
        <div
          id="wizardStepScroll"
          className={styles.stepHolder}
          style={isEditBlueprint && isAdvanced === true ? {} : { width: "100%" }}
        >
          <div style={{ width: "100%" }}>
            {(blueprintId === "new" || blueprintId === "template" || isEditBlueprint) && id === "new" && start}
            {blueprintId === "template" && id === "new" && modelType === undefined ? "" : stepsContainer}
          </div>
        </div>
        {id !== "new" && rightPanel}
      </div>
    );
  }

  render() {
    const {
      id,
      isEditBlueprint,
      isTableauMode,
      isConsumerMode,
      mini,
      consumer,
      currentStep,
      hasCurrentStep,
      header,
      mode
    } = this.props;

    return (
      <div className={styles.tWizard}>
        {isTableauMode ? (
          <div className={styles.miniW}>{mini}</div>
        ) : isConsumerMode ? (
          <div className={styles.miniW}>{consumer}</div>
        ) : (
          <div className={styles.wizard}>
            {(id === "new" || isEditBlueprint) && <div className={styles.header}>{header}</div>}
            {isEditBlueprint !== true && (mode === PROJECT_MODES.RUN || !mode) && (
              <div className={styles.wizHeader} style={hasCurrentStep ? { height: "62px" } : { height: "0px" }}>
                {currentStep}
              </div>
            )}
            <div
              className={styles.body}
              style={{
                height: id === "new" ? "calc((var(--vh, 1vh) * 100) - 135px)" : "calc((var(--vh, 1vh) * 100) - 135px)"
              }}
            >
              {mode === PROJECT_MODES.RUN
                ? this.renderRun()
                : mode === PROJECT_MODES.MONITOR_GROUP
                  ? this.renderMonitorGroup()
                  : mode === PROJECT_MODES.AUDIT
                    ? this.renderAudit()
                    : this.renderRun()}
            </div>
          </div>
        )}
      </div>
    );
  }
}
